export default "__VITE_ASSET__CsawzFMK__"